import { PostTypes, AttachmentType } from "./enums.js";

export const postContainsVideo = (attachments) => {
  for (let i = 0; i < attachments.length; i++) {
    let att = attachments[i];

    if (att.type == AttachmentType.VIDEO) {
      return true
    }
    return false;

  }
}
export const getPostTypeBasedOnAttachments = (attachments, ogTags) => {
  let is_media_post = false;
  let is_youtube_post = false;
  let is_gif_link = false;

  // Check if attachments got media
  for (let i = 0; i < attachments.length; i++) {
    let att = attachments[i];

    if (
      att.type == AttachmentType.IMAGE ||
      att.type == AttachmentType.VIDEO ||
      att.type == AttachmentType.AUDIO ||
      att.type == AttachmentType.GIF_IMAGE
    ) {
      is_media_post = true;
      break;
    }
    else if (att.type == AttachmentType.YOUTUBE) {
      is_youtube_post = true;
    }
    else if (att.type == AttachmentType.GIF_LINK) {
      is_gif_link = true;
    }

  }
  // If attachments containes a video or an image then its a "Media Post"
  // If attachments got no image nor video and got og-tags then its an "OG tags post"
  // If no og tags , videos or images then its a TEXT only post
  if (is_media_post) return PostTypes.MEDIA;

  if (is_youtube_post) return PostTypes.YOUTUBE;

  if (is_gif_link) return PostTypes.GIF_LINK;

  if (is_media_post == false && ogTags !== null)
    return PostTypes.OG;

  if (self.ogTags == null && is_media_post == false)
    return PostTypes.TEXT;

  throw new Error("Post type was not determined successfully.");

}


export const cutText = (text, maxSize) => {
  if (text.length > maxSize) {
    return text.substring(0, maxSize) + "...";
  } else return text;
}



